// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DailyGoals__isPosting___FN_wM {
    opacity: 0.5;
}

.DailyGoals__root___aNTeq {
    position: relative;
    min-height: 28px;
}

.DailyGoals__loadError___cQWr2 {
    padding: 12px 16px;
    color: hsl(38deg 48% 68% / 0.85);
    font-size: 0.9rem;
    letter-spacing: 0.02em;
}

.DailyGoals__list___XgjwE {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 1;
}

.DailyGoals__fadeInList___yfOVo {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 2px;
}

.DailyGoals__fadeInList___yfOVo > div {
    display: flex;
    justify-content: center;
    width: 100%;
}

.DailyGoals__skeletonList___F5tQY {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    position: relative;
    z-index: 0;
    padding-top: 2px;
}

.DailyGoals__skeletonRow___LzZb8 {
    display: flex;
    align-items: center;
    gap: 10px;
    width: min(90%, 540px);
    min-height: 32px;
    padding: 8px 10px;
    border-radius: 4px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    background: linear-gradient(
        90deg,
        hsl(220deg 12% 18% / 0) 0%,
        hsl(220deg 12% 18% / 0.22) 28%,
        hsl(220deg 10% 10% / 0.16) 50%,
        hsl(220deg 12% 18% / 0.22) 72%,
        hsl(220deg 12% 18% / 0) 100%
    );
    box-shadow: inset 0 1px 0 hsl(0deg 0% 100% / 0.03),
        0 0 0 1px hsl(220deg 18% 6% / 0.1);
    opacity: 0.8;
    animation: DailyGoals__skeletonPulse___Zxkyw 1.9s ease-in-out infinite alternate;
}

.DailyGoals__skeletonRow___LzZb8::after {
    content: "";
    position: absolute;
    inset: 0;
    transform: translateX(-120%);
    background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.03) 35%,
        rgba(255, 255, 255, 0.12) 50%,
        rgba(255, 255, 255, 0.03) 65%,
        rgba(255, 255, 255, 0) 100%
    );
    animation: DailyGoals__skeletonShimmer___zKrg5 1.7s linear infinite;
    pointer-events: none;
}

.DailyGoals__skeletonRowShort___fyATc {
    opacity: 0.65;
}

.DailyGoals__skeletonIcon___JPhj1,
.DailyGoals__skeletonName___VXHFx,
.DailyGoals__skeletonPlus___D4b5y,
.DailyGoals__skeletonMetric___E2mSo {
    display: block;
    border-radius: 999px;
    background: linear-gradient(
        90deg,
        hsl(0deg 0% 100% / 0.08),
        hsl(0deg 0% 100% / 0.2),
        hsl(0deg 0% 100% / 0.08)
    );
}

.DailyGoals__skeletonIcon___JPhj1 {
    width: 14px;
    height: 14px;
    flex: 0 0 14px;
}

.DailyGoals__skeletonName___VXHFx {
    width: 52%;
    max-width: 260px;
    height: 14px;
    flex: 1 1 auto;
}

.DailyGoals__skeletonPlus___D4b5y {
    width: 16px;
    height: 16px;
    flex: 0 0 16px;
}

.DailyGoals__skeletonMetric___E2mSo {
    width: 22px;
    height: 14px;
    flex: 0 0 22px;
    margin-left: auto;
}

@keyframes DailyGoals__skeletonPulse___Zxkyw {
    from {
        opacity: 0.55;
    }

    to {
        opacity: 0.9;
    }
}

@keyframes DailyGoals__skeletonShimmer___zKrg5 {
    from {
        transform: translateX(-120%);
    }

    to {
        transform: translateX(120%);
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"isPosting": `DailyGoals__isPosting___FN_wM`,
	"root": `DailyGoals__root___aNTeq`,
	"loadError": `DailyGoals__loadError___cQWr2`,
	"list": `DailyGoals__list___XgjwE`,
	"fadeInList": `DailyGoals__fadeInList___yfOVo`,
	"skeletonList": `DailyGoals__skeletonList___F5tQY`,
	"skeletonRow": `DailyGoals__skeletonRow___LzZb8`,
	"skeletonPulse": `DailyGoals__skeletonPulse___Zxkyw`,
	"skeletonShimmer": `DailyGoals__skeletonShimmer___zKrg5`,
	"skeletonRowShort": `DailyGoals__skeletonRowShort___fyATc`,
	"skeletonIcon": `DailyGoals__skeletonIcon___JPhj1`,
	"skeletonName": `DailyGoals__skeletonName___VXHFx`,
	"skeletonPlus": `DailyGoals__skeletonPlus___D4b5y`,
	"skeletonMetric": `DailyGoals__skeletonMetric___E2mSo`
};
module.exports = ___CSS_LOADER_EXPORT___;
